import { render, staticRenderFns } from "./AddressCard.vue?vue&type=template&id=ed09b418&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed09b418",
  null
  
)

export default component.exports